// extracted by mini-css-extract-plugin
module.exports =  {"card":"AddGroupCard-i7BG__card","image":"AddGroupCard-UXs1__image","button-outer":"AddGroupCard-vpvY__button-outer"};